import { CircularProgress, Grid, makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Button } from 'shards-react'
import TextFieldComponent from '../utils/TextFieldComponent'
import { gql, useMutation } from '@apollo/client'
import { useHistory } from 'react-router-dom'
import Logo from '../images/qaMate/image.png'
const useStyles = makeStyles(x=>({
    card:{
        [x.breakpoints.down('lg')]:{
            minWidth:'25vw'
        },
        [x.breakpoints.up('lg')]:{
            maxWidth:'25vw'
        }
    }
  }));
export default function Login() {
    const classes = useStyles()
    const [password, setPassword] = useState("")
    const [email, setEmail] = useState("")
    const history = useHistory()

    useEffect(() => {
        localStorage.removeItem('token')
    }, [])
    const LOGIN = gql`
        mutation LogiN($email: String!,$password: String!) {
            login(input: { identifier:$email, password: $password }) {
                jwt,
                user {
                    id
                }
            }
        }
    `
    const [login, { loading }] = useMutation(LOGIN);
    const handleLogin = async () => {

        login({ variables: { email: email, password: password } }).then(res => {
            if (res.data && res.data.login) {
                localStorage.setItem("token", res.data.login.jwt)
                history.push('/meetingNotes')
            }
        }).catch(err => {
            // console.log(err);
        })
    }
    return (
        <Grid container spacing={2} className={classes.card} >
            <Grid item container justify="center">
                <img src={Logo} style={{width:'120px'}} />
            </Grid>
            <Grid item container justify="center" style={{fontWeight:'bold',fontSize:'20px'}}>
                Login
            </Grid>
            <Grid item container >
                <Grid container style={{marginBottom:'5px'}}>Email</Grid>
                
                <TextFieldComponent name="Email" placeholder="Email" value={email} onchange={setEmail} />
            </Grid>
            <Grid item container>
            <Grid container style={{marginBottom:'5px'}}>Password</Grid>

                
                <TextFieldComponent textFieldType="password" name="Password" placeholder="Password" value={password} onchange={setPassword} />
            </Grid>
            <Grid item container>
                <Button
                    color="inherit"
                    theme="accent"
                    size="sm"
                    className="ml-auto"
                    onClick={handleLogin}
                    disabled={loading}
                >
                    Login {loading && <CircularProgress size={14} />}
                </Button>
            </Grid>
        </Grid>
    )
}
